import { db } from "../data/firebase"
import { ConfigsContext } from "./ConfigsContext"
import { collection, addDoc, serverTimestamp} from "firebase/firestore"
import { useState, useContext } from "react";

const trekFee = 1.075;
const rateUrgent = 0.8;
const rateRegular = 0.05;
const divisorUrgent = 120;
const divisorRegular = 8;
const MIN_PRICE = 14.25;

let mileage = 100;

export default function BoxConfig({user})
{
  const { setConfigs } = useContext(ConfigsContext);

  const [formData, setFormData] = useState({
    from:"",
    to:"",
    weight: "",
    length: "",
    width: "",
    height: "",
    urgent: false,
    regular: false,
    priceR: 0,
    priceU: 0,
    price: 0,
    shipperId: user.uid,
    riderId: "",
  });

    if (!user)
    {
      return (
        <div>
      <p className="tab-button"> loading</p>
      </div>
      )
    }

  let priceReg = 0;
  let priceUrg = 0;



  const handleChange = (e) =>
  {
    const { name, value } = e.target; //what is e target
    console.log('This is e: ', e);
    console.log('This is e.target: ', e.target);

    console.log('This is e.target.value: ', e.target.value);

    setFormData((prev) => (
      {
        ...prev,
        [name]: value
      }
    ));
  };

    const handleCheckbox = (e) =>
  {
    
    const name = e.target.name;
    const value  = e.target.checked; 

    setFormData((prev) => (
      {
        ...prev,
        [name]: value
      }
    ));
    
  };

  const handleSubmit = async (e) => 
  {
   
    e.preventDefault();

    const newEntry =
    {
      ...formData,
      createdAt: serverTimestamp()
    };

    try
    {
      const docRef = await addDoc(collection(db, "users", user.uid, "dimensions"), newEntry);
      setConfigs((prev) => [...prev, {...newEntry, id: docRef.id}]);
      setFormData(
        {
          weight: "", length: "", width: "", height:"", regular:"", urgent:"", priceR:0, priceU: 0
        });

    }
    catch (err)
    {
      console.error("Error saving to firebase", err);
    }
  };
  

  function handlePrice()
  {
    const weight = parseFloat(formData.weight) || 0;
    const volume = (parseFloat(formData.length) || 0) *
    (parseFloat(formData.width) || 0) *
    (parseFloat(formData.height) || 0);

    if (weight*volume===0)
      {
        return 0;
      }

    let magnitude = ((volume**0.4)/divisorRegular)*(weight**0.8);
    priceReg = trekFee*((mileage * rateRegular) + magnitude);

    priceReg = priceReg.toFixed(2);
    console.log('should be reg price: ', priceReg);

    setFormData(prev => ({ ...prev, priceR: priceReg > 15 ? priceReg : MIN_PRICE })); 

    magnitude = ((volume**0.75)/divisorUrgent)*weight;
    priceUrg = trekFee*((mileage * rateUrgent) + magnitude);

    priceUrg = priceUrg.toFixed(2);
    
    setFormData(prev => ({ ...prev, priceU: priceUrg > 15 ? priceUrg : MIN_PRICE })); 
    console.log('should be urgent price: ', priceUrg);

    if (formData.urgent)
    {
    setFormData(prev => ({ ...prev, price: priceUrg })); 
    }
    if (formData.regular)
    {
    setFormData(prev => ({ ...prev, price: priceReg})); 
    }
    console.log('Should be global price:', formData.price)
  }


  return(
    <form onSubmit={handleSubmit}>
      <input
      className="tab-button"
      name="from"
      value={formData.from}
      onChange={handleChange}
      placeholder="From"
      />
      <input
      className="tab-button"
      name="to"
      value={formData.to}
      onChange={handleChange}
      placeholder="To"
      />
      <input
      className="tab-button"
      name="weight"
      value={formData.weight}
      onChange={handleChange}
      placeholder="Weight"
      />
      <input
      className="tab-button"
      name="length"
      value={formData.length}
      onChange={handleChange}
      placeholder="Length"
      />
      <input
      className="tab-button"
      name="width"
      value={formData.width}
      onChange={handleChange}
      placeholder="Width"
      />
      <input
      className="tab-button"
      name="height"
      value={formData.height}
      onChange={handleChange}
      placeholder="Height"
      />

      <h3>Price</h3>

        <label className="flexbox-column">
          <section className="flexbox-row">
          Regular: ${formData.priceR}  <input type='checkbox' name='regular' value={formData.regular} defaultChecked={false} onChange={handleCheckbox}/>
          </section>

          <section className="flexbox-row">
          Urgent: ${formData.priceU}  <input type='checkbox' name='urgent' value={formData.urgent} defaultChecked={false} onChange={handleCheckbox}/>
          </section>
        </label>    



      <button className="tab-button" onClick={handlePrice} type="button">Calculate Price</button>

      <button disabled={formData.height==0} className="tab-button" type="submit">Order</button>
    </form>
  )
}

